import React from 'react';
import PropTypes from 'prop-types';
import VideoProject from './VideoProject';

const VideoGrid = ({projects}) => (
  <div>
    {Object.keys(projects).map(id => (
      <VideoProject key={id} project={projects[id]} />
    ))}
  </div>
);

VideoGrid.propTypes = {
  projects: PropTypes.objectOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      media: PropTypes.arrayOf(
        PropTypes.shape({
          thumbnail: PropTypes.shape({
            url: PropTypes.string.isRequired,
          }).isRequired,
          duration: PropTypes.number.isRequired,
          hashed_id: PropTypes.string.isRequired,
          name: PropTypes.string.isRequired,
        })
      ).isRequired,
    })
  ).isRequired,
};

export default VideoGrid;



// WEBPACK FOOTER //
// ./src/components/videos/VideoGrid.js